"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var next_components_1 = require("@dotdev/next-components");
var PageTitle = /** @class */ (function (_super) {
    __extends(PageTitle, _super);
    function PageTitle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PageTitle.prototype.render = function () {
        return this.props.title || this.props.content ? (React.createElement("section", { className: "pb-2-8" },
            React.createElement("div", { className: "" + (this.props.className ? this.props.className : "text-center px-1-6 md:px-3-4") },
                React.createElement("h1", { className: "font-normal text-navy text-2xl" }, this.props.title),
                this.props.content ? (React.createElement("p", { className: "" + (this.props.pClassName ? this.props.pClassName : "mt-0-8 md:px-4 mx-auto max-w-md text-charcoal leading-normal") }, next_components_1.ShopifyNext.Utils.parseHTML(this.props.content))) : null))) : null;
    };
    return PageTitle;
}(React.PureComponent));
exports.PageTitle = PageTitle;
